import { Box, Card } from '@mui/material';

interface LogoCardProps {
  logoUrl?: string;
  displayName: string;
  primaryColor: string;
  dashboardImageUrl?: string;
}

export const LogoCard = ({ logoUrl, displayName, primaryColor, dashboardImageUrl }: LogoCardProps) => (
  <Box sx={{ mt: 3, mb: 3 }}>
    <Card sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center',
      p: dashboardImageUrl ? 0 : 2,
      backgroundColor: dashboardImageUrl ? 'transparent' : primaryColor,
      backgroundImage: dashboardImageUrl ? 'none' : `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}dd 100%)`,
    }}>
      {dashboardImageUrl ? (
        <img src={dashboardImageUrl} alt={displayName} style={{ height: 'auto', width: '100%', maxHeight: 200, objectFit: 'contain' }} />
      ) : logoUrl ? (
        <img src={logoUrl} alt={displayName} style={{ height: 'auto', width: '100%', maxHeight: 140, objectFit: 'contain' }} />
      ) : null}
    </Card>
  </Box>
);
